import { leadAssignmentRulesApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LEAD_ASSIGNMENT_RULES_ACTION_TYPE = createNamedActions('leadAssignmentRules', {
  GET_RULES: 'GET_RULES',
  CREATE_RULE: 'CREATE_RULE',
  UPDATE_RULE: 'UPDATE_RULE',
  DELETE_RULE: 'DELETE_RULE',
  REORDER_RULES: 'REORDER_RULES',
});

export const getLeadAssignmentRulesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await leadAssignmentRulesApi.getRules();

  return dispatch({
    type: LEAD_ASSIGNMENT_RULES_ACTION_TYPE.GET_RULES,
    payload: Array.isArray(data) ? data : [],
  });
});

export const createLeadAssignmentRuleAction = catchAsyncActionError(dto => async dispatch => {
  const { data } = await leadAssignmentRulesApi.createRule(dto);

  return dispatch({
    type: LEAD_ASSIGNMENT_RULES_ACTION_TYPE.CREATE_RULE,
    payload: data,
  });
});

export const updateLeadAssignmentRuleAction = catchAsyncActionError(
  ({ ruleId, ...dto }) =>
    async dispatch => {
      const { data } = await leadAssignmentRulesApi.updateRule({ ruleId, ...dto });

      return dispatch({
        type: LEAD_ASSIGNMENT_RULES_ACTION_TYPE.UPDATE_RULE,
        payload: data,
      });
    },
);

export const deleteLeadAssignmentRuleAction = catchAsyncActionError(ruleId => async dispatch => {
  await leadAssignmentRulesApi.deleteRule(ruleId);

  return dispatch({
    type: LEAD_ASSIGNMENT_RULES_ACTION_TYPE.DELETE_RULE,
    payload: ruleId,
  });
});

export const reorderLeadAssignmentRulesAction = catchAsyncActionError(
  orderedRuleIds => async dispatch => {
    await leadAssignmentRulesApi.reorderRules({ orderedRuleIds });

    return dispatch({
      type: LEAD_ASSIGNMENT_RULES_ACTION_TYPE.REORDER_RULES,
      payload: orderedRuleIds,
    });
  },
);
